import React from "react";
import { useSelector } from "react-redux";
import {
    Button,
    DataTable,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableHeader,
    TableRow,
    TableToolbar,
    TableToolbarContent,
    TableToolbarSearch,
} from "@carbon/react";
import { Filter } from "@carbon/icons-react";
import { useSorting } from "../../modules/hooks/sorting";

const ADASTable = () => {
    // Get ADAS data from Redux state
    const { adas } = useSelector((state) => state.notification);

    // Define table headers
    const headerData = [
        {
            header: "Fecha",
            key: "timestamp",
            sortDirection: "DESC",
            isDefaultSortable: true,
        },
        {
            header: "Cantidad",
            key: "quantity",
        },
    ];

    // Use sorting hook for table data
    const { headers, rows } = useSorting(adas, headerData);

    // Define the table structure
    const Default = () => (
        <DataTable rows={rows} headers={headers} width="100%">
            {({
                rows,
                headers,
                getHeaderProps,
                getRowProps,
                getTableProps,
                getTableContainerProps,
                onInputChange,
                sortBy,
            }) => (
                <TableContainer {...getTableContainerProps()}>
                    <TableToolbar>
                        <TableToolbarContent>
                            {/* Search functionality */}
                            <TableToolbarSearch onChange={onInputChange} />
                            <Button
                                renderIcon={Filter}
                                kind="secondary"
                                hasIconOnly
                                iconDescription="Filter table"
                            />
                        </TableToolbarContent>
                    </TableToolbar>
                    <Table {...getTableProps()} aria-label="ADAS Table">
                        <TableHead>
                            <TableRow>
                                {headers.map((header, i) => {
                                    const { key, ...rest } = getHeaderProps({
                                        header,
                                        isSortable: (headerData[i]?.sortDirection ?? "NONE") !== "NONE",
                                        onClick: (_, sortState) => sortBy(sortState.sortHeaderKey),
                                    });

                                    return (
                                        <TableHeader
                                            key={key} // pass key explicitly
                                            sortDirection={headerData[i]?.sortDirection ?? "NONE"}
                                            {...rest} // spread the rest of the props without key
                                        >
                                            {header.header}
                                        </TableHeader>
                                    );
                                })}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.map((row) => (
                                <React.Fragment key={row.id}>
                                    <TableRow
                                        {...getRowProps({
                                            row,
                                        })}
                                    >
                                        {row.cells.map((cell) => (
                                            <TableCell key={cell.id}>{cell.value}</TableCell>
                                        ))}
                                    </TableRow>
                                </React.Fragment>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </DataTable>
    );

    return <Default />;
};

export default ADASTable;
